 import excelJS from 'exceljs'
import { save } from 'save-file'
import applyDefaultWorkbookView from '/utils/excel-workbook-view'
import { getVisibleExportColumns } from '/utils/export-data'

const columns = [
  { id: 'id', name: 'Pass ID', item: 'id', width: 25 },
  { id: 'installUrl', name: 'Install URL', item: 'installUrl', width: 100 },
  { id: 'appleUrl', name: 'Apple URL', item: 'appleUrl', width: 100 },
  { id: 'googleUrl', name: 'Google URL', item: 'googleUrl', width: 1000 },
  { id: 'error', name: 'Error', item: 'error', width: 30 },
  { id: 'mailmergeName', name: '_mailmerge.name', item: '_mailmerge.name', width: 40 },
  { id: 'mailmergeEmail', name: '_mailmerge.email', item: '_mailmerge.email', width: 40 },
]
 
 const downloadResultsExcel = async ({ fileName, data, visibleColumns }) => {
    const exportColumns = getVisibleExportColumns(columns, visibleColumns)
    const workbook = new excelJS.Workbook()

    workbook.views = [
      {
        x: 0, y: 0, width: 3, height: 1000,
        firstSheet: 0, activeTab: 1, visibility: 'visible'
      }
    ]

    const font = { name: 'Courier', size: 12, bold: true }

    const passes_worksheet = workbook.addWorksheet("passes")

    const passes_row = passes_worksheet.getRow(1)

    exportColumns.forEach((column, index) => {
      passes_worksheet.getColumn(index + 1).width = column.width
      passes_row.getCell(index + 1).value = column.name
      passes_row.getCell(index + 1).font = font
    })

    data.map((r, i) => {
      const row = passes_worksheet.getRow(i + 2)
      exportColumns.forEach((column, index) => {
        row.getCell(index + 1).value = r[column.item]
        row.getCell(index + 1).font = font
      })
    })

    applyDefaultWorkbookView(workbook)
    const buffer = await workbook.xlsx.writeBuffer()

    await save(buffer, fileName + '.xlsx')
  }

  export default downloadResultsExcel
